import { useBrand, useAuth, Button, BrandWordmark, brandDisplayName } from '@aralere/shared-ui';

export function Landing(): JSX.Element {
  const { brand } = useBrand();
  const { sessionRevoked, signIn } = useAuth();
  return (
    <div className="max-w-3xl mx-auto py-16 text-center">
      <h1 className="font-display text-5xl tracking-tight mb-4">
        <BrandWordmark />
      </h1>
      <p className="text-lg text-[var(--color-muted)] mb-8 min-h-[1.75rem]">
        {brand?.tagline ?? '\u00A0'}
      </p>
      {sessionRevoked ? (
        <p className="text-sm text-[var(--color-muted)] mb-4">
          This session was signed out everywhere. Continue to sign in again.
        </p>
      ) : null}
      <Button size="lg" onClick={() => signIn()}>
        Client sign-in
      </Button>
      <p className="mt-6 text-sm text-[var(--color-muted)]">
        {brand ? `New to ${brandDisplayName(brand.name)}? Contact us to get started.` : 'Contact us to get started.'}
      </p>
    </div>
  );
}
